define('all/header',['jquery', 'all/player/session', 'all/player/login', 'all/pretty-links'], function ($, session, login, prettyLinks) {
    'use strict';
    var LAST_PRODUCT_PAGE_COOKIE = 'lastProduct';
    var startPage = '/';

    function gotoMyAccount(event) {
        event.preventDefault();
        location.href = prettyLinks.getLink('MyPages', 'MyAccount');
    }

    function gotoStartPage(event) {
        event.preventDefault();
        $.removeCookie(LAST_PRODUCT_PAGE_COOKIE, { path: '/' });
        location.href = startPage;
    }

    function setOnLogoClick(onLogoClick) {
        $('#logo').find('a').off('click').on('click', onLogoClick);
    }

    function onLogin() {
        $('#cnt-login-bar,#cnt-newcustomer-bar').hide();

        $('#cnt-player-bar').show();
        $('#logo').find('a').attr('href', prettyLinks.getLink('MyPages', 'MyAccount'));
        setOnLogoClick(gotoMyAccount);
    }

    function onLogout() {
        $('#cnt-player-bar').hide();
        $('#logo').find('a').attr('href', startPage);
        setOnLogoClick(gotoStartPage);
    }

    $(session).on('login', onLogin);
    $(session).on('logout', onLogout);

    if (session.authenticated) {
        onLogin();
    } else {
        onLogout();
    }
});

